/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { visualsControllerGetAllVisuals } from '../fn/visuals-controller/visuals-controller-get-all-visuals';
import { VisualsControllerGetAllVisuals$Params } from '../fn/visuals-controller/visuals-controller-get-all-visuals';
import { VisualsListResponse } from '../models/visuals-list-response';


/**
 * API endpoints for visuals assets CRUD operations.
 */
@Injectable({ providedIn: 'root' })
export class VisualsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `visualsControllerGetAllVisuals()` */
  static readonly VisualsControllerGetAllVisualsPath = '/planning-projects/v1/visuals';

  /**
   * API endpoint to get all visuals based on query parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visualsControllerGetAllVisuals()` instead.
   *
   * This method doesn't expect any request body.
   */
  visualsControllerGetAllVisuals$Response(params?: VisualsControllerGetAllVisuals$Params, context?: HttpContext): Observable<StrictHttpResponse<VisualsListResponse>> {
    return visualsControllerGetAllVisuals(this.http, this.rootUrl, params, context);
  }

  /**
   * API endpoint to get all visuals based on query parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visualsControllerGetAllVisuals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visualsControllerGetAllVisuals(params?: VisualsControllerGetAllVisuals$Params, context?: HttpContext): Observable<VisualsListResponse> {
    return this.visualsControllerGetAllVisuals$Response(params, context).pipe(
      map((r: StrictHttpResponse<VisualsListResponse>): VisualsListResponse => r.body)
    );
  }

}
